import Custom404 from '@pages/404'
import {
  breakpoints,
  Loader,
  PwaRedirect,
  useMediaQuery,
  useOverflowDebuggerInDev,
} from '@wome/ui'
import { useRouter } from 'next/router'
import React, { CSSProperties } from 'react'

import s from './styles.module.scss'

import { isDebug } from '@/lib/constants'
import { OwnerSpaceModeEnum } from '@/lib/graphql'

import Head, { HeadProps } from '@/components/common/head'

import { useAuth } from '@/providers/auth/useAuth'
import { useHouse } from '@/providers/useHouse'

import Header from './header/header'
import Scrollbars from './scrollbars/scrollbars'
import { getPermissionAccessPage } from './utils/handlePermissionAccessPage'

type Props = {
  children?: React.ReactNode
  headProps?: HeadProps
  hideHeader?: boolean
  hideFooter?: boolean
  style?: CSSProperties
  isBookingPage?: boolean
  isSpecialConditionsPage?: boolean
  isAuthenticateTokenExpired?: boolean
  permission?: OwnerSpaceModeEnum
}

const PageLayout = ({
  children,
  headProps,
  hideHeader = false,
  style = { padding: '0' },
  isBookingPage,
  isSpecialConditionsPage,
  isAuthenticateTokenExpired,
  permission = OwnerSpaceModeEnum.FULL,
}: Props) => {
  const { isLoadingAuthentication } = useAuth()
  const { house } = useHouse()
  const router = useRouter()
  useOverflowDebuggerInDev(isDebug)
  const isMobile = useMediaQuery(breakpoints.newMobile)

  if (isLoadingAuthentication) {
    return <Loader />
  }

  const { granted, redirectUrl, showCustom404 } = getPermissionAccessPage({
    house,
    permission,
  })

  if (!granted) {
    if (showCustom404) {
      return <Custom404 />
    }
    if (redirectUrl) {
      router.push(redirectUrl)
    }
    return null
  }

  return (
    <>
      <Head {...headProps} />
      {isMobile ? (
        <PwaRedirect />
      ) : (
        <>
          {!hideHeader && (
            <Header
              isAuthenticateTokenExpired={isAuthenticateTokenExpired}
              isBookingPage={isBookingPage}
              isSpecialConditionsPage={isSpecialConditionsPage}
            />
          )}
          <main className={s.main}>
            <Scrollbars innerStyle={style}>{children}</Scrollbars>
          </main>
        </>
      )}
    </>
  )
}

export default PageLayout
